/* __next_internal_client_entry_do_not_use__ RETRIEVAL_QUERY_KEY,RetrievalQueries auto */ import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Storage } from "@faire/web--source/common/Storage";
import { Suspense } from "react";
import { useState } from "react";
import * as React from "react";
import { LazyRetrievalQueriesDownloadModal } from "@faire/retailer/features/RetrievalQueries/LazyRetrievalQueriesDownloadModal";
import { RetrievalQueriesButton } from "@faire/retailer/features/RetrievalQueries/RetrievalQueriesButton";
import { getSettingShouldDisplayRetrievalModal } from "@faire/retailer/settings/getSettingShouldDisplayRetrievalModal";
export var RETRIEVAL_QUERY_KEY = "retrieval_queries";
export var RetrievalQueries = function(param) {
    var allRetrievalQueries = param.allRetrievalQueries, requestId = param.requestId;
    var _useState = _sliced_to_array(useState(false), 2), isRetrievalModalOpen = _useState[0], setIsRetrievalModalOpen = _useState[1];
    if (getSettingShouldDisplayRetrievalModal() && (allRetrievalQueries === null || allRetrievalQueries === void 0 ? void 0 : allRetrievalQueries.length) && requestId) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(RetrievalQueriesButton, {
                    onClick: function() {
                        setIsRetrievalModalOpen(true);
                    }
                }),
                isRetrievalModalOpen ? /*#__PURE__*/ _jsx(Suspense, {
                    fallback: null,
                    children: /*#__PURE__*/ _jsx(LazyRetrievalQueriesDownloadModal, {
                        retrievalQueries: allRetrievalQueries,
                        requestId: requestId,
                        onClose: function() {
                            setIsRetrievalModalOpen(false);
                            Storage.local.removeItem(RETRIEVAL_QUERY_KEY);
                        }
                    })
                }) : null
            ]
        });
    } else {
        return null;
    }
};
